module.exports = __webpack_public_path__ + "static/media/anatomia.dd364782.png";